import NewsDetailLayout from './news/NewsDetailLayout';
import { shareData } from './news/newsDetailData';

const ShareNewsDetail = () => <NewsDetailLayout data={shareData} />;
export default ShareNewsDetail;
